// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1-ebY","unreadBadge":"styles_unreadBadge__2_zWy","modalContent":"styles_modalContent__2CtKn","modal":"styles_modal__2H3pn"};